function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import componentStyles from "./language-picker-item-component.scss";
import classnames from "classnames";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
class LanguagePickerItemComponent extends PureComponent {
    render() {
        const { label, isSelected } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            onClick: this.onClick,
            tabIndex: 0,
            onKeyDown: this.onKeyDown,
            role: "option",
            "aria-selected": isSelected,
            className: `jsx-${componentStyles.__hash}` + " " + (classnames("language-picker-item-component", {
                "language-selected": isSelected
            }) || ""),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "language-picker-item-label",
                    children: label
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "onClick", ()=>{
            const { id, onClick } = this.props;
            onClick(id);
        });
        this.onKeyDown = generateOnKeyDownHandler(this.onClick);
    }
}
export { LanguagePickerItemComponent as default };
